import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { industries } from "./industryData";

export default function IndustrySolutionsSlider() {
  const [index, setIndex] = useState(0);

  // Auto-play effect
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % industries.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [index]);

  const next = () => {
    setIndex((prev) => (prev + 1) % industries.length);
  };

  const prev = () => {
    setIndex((prev) =>
      prev === 0 ? industries.length - 1 : prev - 1
    );
  };

  return (
    <section className="bg-[#f5f5f5] py-12 sm:py-16 lg:py-20">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">

        {/* Heading Area */}
        <div className="mx-auto flex max-w-5xl flex-col items-center text-center">
          <h2 className="text-3xl font-bold leading-tight text-[#222] sm:text-4xl md:text-5xl">
            Industry-specific solutions that cater to
            <br className="hidden md:block" /> industry-specific needs.
          </h2>
          <p className="mx-auto mt-4 max-w-4xl text-center text-base leading-relaxed text-gray-600 sm:mt-6 sm:text-lg lg:leading-8">
            With specialization in Industry-specific solutions, Veyonta Track
            Technology creates pre-configured solutions ready for deployment.
            By leveraging the knowledge and experience of our experts, our
            company offers cost-effective GPS tracking systems for businesses.
          </p>
        </div>

        {/* Slider Area */}
        <div className="mt-10 flex flex-col items-center sm:mt-16">

          {/* Image & Navigation Wrapper */}
          <div className="relative flex w-full max-w-[850px] items-center justify-center">
            
            {/* Left Button */}
            <button
              onClick={prev}
              className="absolute -left-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-[#df8b2d] text-white shadow-lg transition hover:scale-105 sm:-left-6 sm:h-12 sm:w-12 md:-left-12 md:h-[60px] md:w-[60px]"
            >
              <ChevronLeft className="h-6 w-6 sm:h-8 sm:w-8" />
            </button>

            {/* Image Carousel Window (overflow-hidden masks the off-screen images) */}
            <div className="w-full px-10 sm:px-12 md:px-0">
              <div className="overflow-hidden">
                {/* The sliding track */}
                <div 
                  className="flex transition-transform duration-500 ease-in-out"
                  style={{ transform: `translateX(-${index * 100}%)` }}
                >
                  {industries.map((item, i) => (
                    <div key={i} className="w-full shrink-0">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="mx-auto w-full max-w-[600px] object-contain"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Button */}
            <button
              onClick={next}
              className="absolute -right-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-[#df8b2d] text-white shadow-lg transition hover:scale-105 sm:-right-6 sm:h-12 sm:w-12 md:-right-12 md:h-[60px] md:w-[60px]"
            >
              <ChevronRight className="h-6 w-6 sm:h-8 sm:w-8" />
            </button>
          </div>

          {/* Bottom Content Area Carousel */}
          <div className="mt-8 w-full max-w-[700px] overflow-hidden sm:mt-10">
            {/* The sliding track for text */}
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${index * 100}%)` }}
            >
              {industries.map((item, i) => (
                <div key={i} className="flex w-full shrink-0 flex-col items-center px-4 text-center">
                  <h3 className="text-2xl font-bold text-[#222] sm:text-3xl md:text-4xl">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-center text-base leading-relaxed text-gray-600 sm:mt-4 sm:text-lg lg:leading-8">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}